<template>
  <div class="vx-row mb-6">
    <div class="vx-col w-full">
      <h5 class="mb-6">
        {{ $t('Genders') }}
      </h5>
      <vs-row>
        <vs-col v-for="(gender, index) in targetGenders" :key="'target-gender-' + adsetIndex + '-' + index" vs-type="flex" vs-justify="start" vs-align="center" vs-w="4">
          <vs-checkbox :disabled="disableGenders" v-if="isGenderUnchecked(gender.id)" :checked="false" id="create-campaign-s3-genders-checkbox" class="ml-0" v-model="genders" :vs-value="gender.id">{{ $t(gender.name) }}</vs-checkbox>

          <vs-checkbox :disabled="disableGenders" v-else @input="gaGenders(gender)" id="create-campaign-s3-genders-checkbox" class="ml-0" v-model="genders" :vs-value="gender.id">{{ $t(gender.name) }}</vs-checkbox>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    value: {
      type: Array,
      required: true
    },
    adsetIndex: {
      type: Number,
      required: true
    },
    advertisingChannel: {
      type: Object,
      required: true
    },
    objective: {
      type: String,
      required: false
    },
    editing: {
      type: Boolean,
      required: true
    },
    acceptanceStatus: {
      type: Boolean | null,
      required: true
    }
  },
  mounted () {
    if (this.genders.length === 0) {
      this.genders = this.targetGenders.map(gender => gender.id)
    }
  },
  computed: {
    targetGenders () {
      return this.$store.getters['campaign/targetingLookups'].genders
    },

    disableGenders () {
      return this.editing && !this.advertisingChannel.supports_update_targeting && this.acceptanceStatus
    },

    genders: {
      set (val) {
        this.$emit('input', val)
      },
      get () {
        return this.value
      }
    }
  },
  methods: {
    gaGenders (gender) {
      this.$gtag.event(`Step3_Genders_${gender.name}`)
    },

    isGenderUnchecked (genderId) {
      return !this.genders.includes(genderId)
    }
  }
}
</script>
